import { render, staticRenderFns } from "./documentoFormForm.vue?vue&type=template&id=47d65f4c"
import script from "./documentoFormForm.vue?vue&type=script&lang=js"
export * from "./documentoFormForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports